import { Box, Button, Link, TextField, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { LoadingComponent } from "@gui/widgets/LoadingComponent";
import { AsyncStatus } from "@gui/widgets/A11y";
import { RegisterProps } from "./register.types";
import { useRegisterViewModel } from "./register.vm";
import "./register.css";

export function Register(props: RegisterProps) {
	const vm = useRegisterViewModel(props);

	return (
		<Box maxWidth="md" margin="auto" component="form" onSubmit={vm.handleSubmit} noValidate className="register-form">
			{vm.loading && (
				<Box display="flex" justifyContent="center" alignItems="center" aria-busy="true">
					<AsyncStatus state="loading" loadingText="Creating your account…" />
					<LoadingComponent />
				</Box>
			)}
			<Box display="flex" justifyContent="space-between" className="name-fields">
				<TextField
					variant="outlined"
					margin="normal"
					required
					disabled={vm.loading}
					fullWidth
					id="firstName"
					label="First Name"
					name="firstName"
					autoFocus
					onBlur={vm.handleFirstNameChange}
					data-sentry-component="First Name Field"
				/>
				<TextField
					variant="outlined"
					margin="normal"
					required
					disabled={vm.loading}
					fullWidth
					id="lastName"
					label="Last Name"
					name="lastName"
					onBlur={vm.handleLastNameChange}
					data-sentry-component="Last Name Field"
				/>
			</Box>
			<TextField
				variant="outlined"
				margin="normal"
				required
				error={!!vm.emailError}
				helperText={vm.emailError}
				disabled={vm.loading}
				fullWidth
				id="email"
				label="Email"
				name="email"
				autoComplete="email"
				onBlur={vm.handleEmailChange}
				data-sentry-component="Email Field"
			/>
			<TextField
				variant="outlined"
				margin="normal"
				error={!!vm.passwordError}
				helperText={vm.passwordError}
				required
				disabled={vm.loading}
				fullWidth
				name="password"
				label="Password"
				type="password"
				id="password"
				autoComplete="current-password"
				onBlur={vm.handlePasswordChange}
				data-sentry-component="Password Field"
			/>
			<TextField
				variant="outlined"
				margin="normal"
				error={!!vm.confirmPasswordError}
				helperText={vm.confirmPasswordError}
				required
				disabled={vm.loading}
				fullWidth
				name="Confirm password"
				label="Confirm Password"
				type="password"
				id="Confirm password"
				autoComplete="confirm-password"
				onBlur={vm.handleConfirmPasswordChange}
				data-sentry-component="Confirm Password Field"
			/>
			{/* Unlike Login's, this element genuinely populates — register.vm sets it for the
			    "email already exists" and generic-failure paths — so it is a real live region.
			    Mounted only when non-empty, so it is not a second ambiguous `getByRole("alert")`. */}
			{vm.error && (
				<Typography variant="body2" color="error" align="center" className="error-message" role="alert">
					{vm.error}{" "}
					<Link component={RouterLink} to="/login">
						Log in
					</Link>
				</Typography>
			)}

			<Button
				type="submit"
				fullWidth
				variant="contained"
				color="primary"
				disabled={vm.loading}
				data-sentry-component="Submit Button"
			>
				Register
			</Button>
		</Box>
	);
}
